import { useNavigate } from 'react-router-dom';

const faqs = [
  {
    q: 'What is Basetao Spreadsheet?',
    a: 'A Basetao Spreadsheet is an organized document that compiles product links, pricing details, and shopping insights for products available through the Basetao platform. It helps shoppers discover products, compare prices, and make informed buying decisions with curated information organized by category.',
  },
  {
    q: 'Is Basetao legit and safe to use?',
    a: 'Basetao is a legitimate shopping agent platform that has served thousands of international customers. The platform connects buyers with products from Chinese marketplaces, handles quality inspection, and manages international shipping. Always verify seller ratings and use the platform\'s buyer protection features for a safe shopping experience.',
  },
  {
    q: 'How much does Basetao shipping cost?',
    a: 'Basetao shipping costs vary based on package weight, dimensions, destination country, and shipping method selected. The platform offers multiple shipping options including economy air mail, express carriers, and sea freight. Using a Basetao Spreadsheet can help you estimate and compare shipping costs across different products and methods.',
  },
  {
    q: 'Does Basetao offer coupons or discount codes?',
    a: 'Yes, Basetao periodically offers promotional coupons and discount codes for both new and returning customers. These can include shipping discounts, service fee reductions, and seasonal promotions. Check the Basetao Spreadsheet resources regularly for updated coupon information and money-saving tips.',
  },
  {
    q: 'Where is the Basetao warehouse located?',
    a: 'Basetao operates warehouse facilities in China where purchased products are received, inspected, and stored before international shipping. The warehouse team performs quality checks, takes inspection photos, and consolidates multiple orders into single shipments to help reduce overall shipping costs.',
  },
  {
    q: 'How can I use Basetao Spreadsheet to shop better?',
    a: 'To use a Basetao Spreadsheet effectively, browse the organized product categories to discover trending finds, compare prices and quality notes, refer to shipping cost estimates to plan your budget, check for available coupon codes, and use the community insights to avoid common purchasing mistakes.',
  },
];

export default function FAQ() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            Everything you need to know about Basetao Spreadsheet resources and shopping tools.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-100 rounded-lg">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/basetao-spreadsheet-guide')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Read The Complete Basetao Spreadsheet Guide
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}